// empty vue instance that handles events between sibling components
import Vue from 'vue'
const EventHandler = new Vue()
export default EventHandler
